import { Row, Col, Statistic, Card, Typography } from "antd";
import { useUsageReport } from "../../api/Admin";
import ContentLayout, { ContentTitle } from "../../layout/ContentLayout";
import { Column, Line } from "@ant-design/charts";
import Sidebar from "../Join/components/ParticipantLayouts/Sidebar";
import SidebarLayout from "../../layout/SidebarLayout";

const UsageReport = () => {
  const { data } = useUsageReport();
  return (
    <ContentLayout fullpage>
      <ContentTitle>Usage Report</ContentTitle>
      <ReportSection title="Sessions" data={data?.sessions} />
      <ReportSection title="User Signups" data={data?.users} />
      <ReportSection title="Applications" data={data?.applications} />
    </ContentLayout>
  );
};

const ReportSection = ({ title, data }) => {
  return !data ? null : (
    <>
      <Typography.Title level={3}>{title}</Typography.Title>
      <Row gutter={20}>
        <Col span={8}>
          <Card>
            <Statistic value={data?.total} title="Total" />
          </Card>
        </Col>
        <Col span={16}>
          <Card>
            <ColumnChart data={data?.items} />
          </Card>
        </Col>
      </Row>
    </>
  );
};

const ColumnChart = ({ data }) => {
  const config = {
    data,
    height: 200,
    xField: "date",
    yField: "total",
    label: {
      position: "middle",
      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
      },
    },
    yAxis: {
      tickInterval: 1,
      tickCount: 2,
      grid: {
        line: {
          style: { lineWidth: 0 },
        },
      },
    },
    xAxis: {
      tickCount: 2,
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
  };

  // return null;
  return data ? <Line {...config} /> : null;
};

export default UsageReport;
